export default function ServiceTime({ data }) {
  return (
    <div
      className="d-flex flex-wrap px-2 pt-4 pb-3"
      style={{
        backgroundColor: "mediumpurple",
        // width: "100%",
        height: "auto",
        lineHeight: "1.7",
        borderRadius: "10px",
        margin: "0 10px",
      }}
    >
      {data?.avgService?.map((value) => (
        <ServiceTimeItem title={value.title} value={value.average_time} />
      ))}
    </div>
  );
}

export function ServiceTimeItem({ title, value }) {
  return (
    <div
      className="col-12 col-sm-6 col-md-4 ps-2 d-flex flex-wrap my-3 pe-2"
      style={{ color: "white", direction: "rtl" }}
    >
      <div> {title}:</div>
      <div className="ms-2" style={{ fontWeight: "bold" }}>
        {value ? `${Math.floor(value * 60)} دقیقه` : "0"}
      </div>
    </div>
  );
}
